import * as React from 'react'
import { Calendar } from 'react-feather'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import ScheduleTourModal from 'main/components/tour/ScheduleTourModal'
import { NAV_MODALS } from 'main/hooks/useSSOContext'
import { palette, Popover } from 'main/ui'
import useNavContextModal from '../common/useNavContextModal'

import CTAButton from '../common/CTAButton'
import NotTouringTooltip from './NotTouringTooltip'

interface IProps extends RouteComponentProps {
  disabled: boolean
  full: boolean
  label: string
  schoolId: number
}

function ScheduleTour(props: IProps) {
  const { disabled, full, label, schoolId, location } = props

  const [displayPopover, setDisplayPopover] = React.useState<boolean>(false)

  const [isModalOpen, openModal, closeModal] = useNavContextModal(
    NAV_MODALS.SCHEDULE_TOUR,
    location.pathname,
  )

  return (
    <Popover
      body={<NotTouringTooltip />}
      isOpen={displayPopover}
      onRequestClose={() => setDisplayPopover(false)}
    >
      <div>
        <CTAButton
          full={full}
          icon={<Calendar color={palette.white} />}
          kind={disabled ? 'soft_disabled' : 'regular'}
          label={label}
          pendo="school-page-schedule-tour-button"
          onClick={() => handleOnClick()}
        />
        {isModalOpen && (
          <ScheduleTourModal schoolId={schoolId} onRequestClose={() => closeModal()} />
        )}
      </div>
    </Popover>
  )

  function handleOnClick() {
    return disabled ? setDisplayPopover(true) : openModal()
  }
}

export default withRouter(ScheduleTour)
